var _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    id: "L2",
    className: "svg-loader",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 50,
    cy: 50,
    r: 48
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeLinecap: "round",
    stroke: "#fff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 50,
    y1: 50,
    x2: 85,
    y2: 50.5,
    transform: "rotate(206.617 50 50)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "2s",
    type: "rotate",
    from: "0 50 50",
    to: "360 50 50",
    repeatCount: "indefinite"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeLinecap: "round",
    stroke: "#fff",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 50,
    y1: 50,
    x2: 49.5,
    y2: 74,
    transform: "rotate(195.549 50 50)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "15s",
    type: "rotate",
    from: "0 50 50",
    to: "360 50 50",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinClock);
export default __webpack_public_path__ + "static/media/spin_clock.2c37d027d310f05eb4c6fa0dc96a5848.svg";
export { ForwardRef as ReactComponent };